import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import './plugins/mintui.js';
import axios from "axios";
import 'lib-flexible'
import './assets/scss/comm.scss';


Vue.config.productionTip = false;

axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    if (config.method == 'post') {
      //let requestBody = {body: config.data};
      //config.data = requestBody;
    }else {
      //let requestBody = {body: config.params};
      //config.params = requestBody;
    }
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);
axios.interceptors.response.use(function(response){
  //对响应数据做些事
  if(response.data.head && response.data.head.resCode) {
    if(response.data.head.resCode == '200001001'){//学员
      router.replace({
        path: "/login",
        query: {redirect: router.currentRoute.fullPath,code: response.data.head.resCode}
      })
    }else if(response.data.head.resCode == '200001002'){//销售
      router.replace({
        path: "/logincustomer",
        query: {redirect: router.currentRoute.fullPath,code: response.data.head.resCode}
      })
    }
    
  }
  return response;
},function(error){
  //请求错误时做些事
  return Promise.reject(error);
})

// 根据路由设置标题
router.beforeEach((to, from, next) => {
  /*路由发生改变修改页面的title */
  if(to.meta.title) {
    document.title = to.meta.title
  }
  next();
});

Vue.prototype.$http= axios; 
let baseUrl = '/kaifa/';
//let baseUrl = 'http://192.168.41.179:4000/mock/17/'; 

baseUrl = process.env.NODE_ENV === 'development' ? baseUrl : '/'
Vue.$baseUrl = Vue.prototype.$baseUrl = baseUrl;

let resMsg = (res, handle) => {
	return new Promise((resolve, reject) => {
        if (res.data.head.resCode == 0) {
          if (handle) {
            Vue.$toast(handle + '成功');
          }
          resolve('200 OK');
        }else{
          Vue.$toast(res.data.head.resMessage);	
          reject(res.data.head.resMessage);            
        }
  })
}
Vue.$resMsg = Vue.prototype.$resMsg = resMsg;



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
